import { BasePresenceSensor, type PresenceSignal } from "./base-presence";

export class X001APresenceSensor extends BasePresenceSensor {
  protected parse(data: string): PresenceSignal | null {
    const aMatch = data.match(/X001A\[(\d{1,2})\]/i);
    if (!aMatch || !aMatch[1]) {
      return null;
    }

    const code = aMatch[1];
    const value = Number.parseInt(code, 10);
    if (value === 1) {
      return { state: 'left', code };
    }
    if (value >= 2 && value <= 10) {
      return { state: 'entered', code };
    }
    return null;
  }
}
